import { render, staticRenderFns } from "./ParlaySelectedInfo.vue?vue&type=template&id=7f56a596&scoped=true&"
import script from "./ParlaySelectedInfo.vue?vue&type=script&lang=js&"
export * from "./ParlaySelectedInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParlaySelectedInfo.vue?vue&type=style&index=0&id=7f56a596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56a596",
  null
  
)

export default component.exports